import React from 'react';
import styles from './UploadInstructions.css';

type Props = {
    instructions: React.ReactNode;
    dataTestId: string;
};
const UploadInstructions = ({ instructions, dataTestId }: Props) => {
    return (
        <>
            <hr className={styles.divider} />
            <div className={styles.uploadInstructions} data-testid={dataTestId}>
                {instructions}
            </div>
        </>
    );
};

export default UploadInstructions;
